<style lang="less">
@import "../../../../styles/common-table-list.less";
</style>
<template>
    <div class="center-table-list" style="position:relative">
        <div class="table-list" style="margin-top:25px">
            <div class="table-list-title">
                <span style="margin-left:25px">我的取证</span>
                <div class="choose-group">
                    <span class="choose-group-span">时间</span>
                    <Date-picker :value="dateVal" format="yyyy-MM-dd" type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 200px" @on-change="changeDate"></Date-picker>  
                    <div class="father-box-input">
                        <input v-model="nameVal" placeholder="请输入证据标题" class="select-input-self"  @keyup.enter="changeName" />
                        <img src="@/assets/search.png" class="search-icon" @click="changeName" />
                    </div>                    
                    <button class="btn-84" @click="changeName"  style="margin-right:30px">查询</button>
                    <button class="btn-84" style="margin:0px 30px 0px 0px" @click="goquzheng">新增取证</button>
                </div>
            </div>            
            <Row class="table-style-size">
                <i-col span="10">页面截图</i-col>
                <i-col span="3">取证时间</i-col>
                <i-col span="3">证书</i-col>
                <i-col span="3">状态</i-col>
                <i-col span="5">操作</i-col>
            </Row>
            <div v-if="records.length>0">
                <Row class="table-style-size table-style-body" style="height:90px"  v-for="(item,index) in records" :key="index">        
                    <i-col span="10"  class="evdience-table">
                        <div v-if="item.screenshotUrl==''||item.screenshotUrl==null"><img src="@/assets/defalut.png" /></div>  
                        <div v-else><img :src="item.screenshotUrl+'?x-image-process=image/resize,m_fixed,w_84,h_60'" /></div>   
                        <div style="margin-left:30px;text-align:left">
                            <p style="margin-bottom:11px" class="notwrap" v-if ='currentIndex == index ? false : true'>
                                <Tooltip :content="item.name" placement="top"><span style="display:inline-block;width:250px;height:21px;" class="notwrap">{{item.name}}</span></Tooltip>
                                <img src="@/assets/bianji.png" style="width:12px;height:12px;" class="bianji" @click ="editeRemark(index,item.name)" />
                            </p>
                            <div v-else style="width:262px">
                                <div class="editeRemark">
                                    <input v-model="titleVal" placeholder="请输入证据标题" class="editeRemark-input" maxlength="40" />
                                    <img src="@/assets/wancheng.png" class="editeRemark-search-icon" @click="changeTitle(item.id,item.orderSeqNo)" />
                                </div> 
                            </div>                   
                            <Tooltip :content="item.url" placement="top"><p style="color:#4E8CEE;width:250px" class="notwrap">{{item.url}}</p></Tooltip>
                        </div> 
                    </i-col>        
                    <i-col span="3">{{item.createDate}}</i-col>
                    <i-col span="3" v-if="item.evidenceOrder.status=='证书已生成'"><a :href="item.evidenceOrderExtends.certSignaturePdfUrl"  target="_black"><img src="@/assets/evidence-open.png" class="inco-img" /></a></i-col>
                    <i-col span="3" v-else><img src="@/assets/evidence-close.png" class="inco-img" /></i-col>
                    <i-col span="3">{{item.evidenceOrder.status}}</i-col>
                    <i-col span="5">
                        <button class="btn-84" @click="pushInfo(item.id)" v-if="item.evidenceOrder.status!='取证失败'">详情</button>
                        <button class="btn-84" @click="againSubmit(item.id)" v-if="item.evidenceOrder.status=='取证失败'">重新截取</button>
                        <div class="showphotow" v-if="item.evidenceOrder.status=='证书已生成'">
                            <button class="btn-84">更多操作</button>
                            <div class="showdiasy">
                                <p @click="openVerify(item.orderSeqNo)">证书核验</p>
                                <p @click="downBook(item.orderSeqNo)"><a :href="item.evidenceOrderExtends.certSignaturePdfUrl"  target="_black">下载证书</a></p>
                                <p @click="downUrl(item)">下载数据包</p>
                                <p @click="downBcBook(item.orderSeqNo)">下载BC文件</p>
                            </div>
                        </div>                                        
                    </i-col>
                </Row>
                <div class="commont-page" style="position:absolute;bottom:10px;left:50%;transform:translate(-50%, -50%)">
                    <Page :page-size="pageSize"  @on-change="changepage" :total="total" size="small" show-total show-elevator class="page-size-style"></Page><span class="page-total-span">/&nbsp;{{pages}}页</span>
                </div>
            </div>
            <div class="empty-box" v-if="records.length<=0&&flag">
                <img src="@/assets/empty.png" class="empty-img" />
                <p>表单暂无数据哦～</p>
            </div>
        </div>
    </div>
    
</template>

<script>
import { _getByPage,_updateTitle,_getresave } from "@/api/evidence.js";
import Cookies from "js-cookie";
export default {
    name:'myEvidence',
    data(){
    return{
        total:0,
        pages:0,
        pageNumber:1,
        pageSize:6,
        records:[],
        dateVal:[],
        beginTime:"",
        endTime:"",
        nameVal:"",
        currentIndex:null,
        titleVal:"",
        flag:false,
        flagType:'f1',
    }
  },
  methods: {
    goquzheng(){
      this.$router.push({ path:'/evidenceWeb' })
    },
    getByPage(){ 
        let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';   
        const data = {
            pageNumber:this.pageNumber,
            pageSize:this.pageSize,
            sort:'create_date',
            order:'desc',
            registerId:userInfo && userInfo.id?userInfo.id:'',
            beginTime:this.dateVal.length>0?this.dateVal[0]:"",
            endTime:this.dateVal.length>0?this.dateVal[1]:"",
            name:this.nameVal
        }
        _getByPage(data).then(res => {
            if(res.code==200){
                this.total=Number(res.result.total);
                this.pages=res.result.pages;
                this.records=res.result.records;
                this.flag=true;
            }
        });            
    },
    //分页
    changepage(index){
        this.pageNumber = index
        this.getByPage()
    },
    //日期
    changeDate(val){
        this.dateVal = val;
        this.pageNumber=1;
        this.getByPage()
    },
    //搜索名称
    changeName(){
        console.log(this.nameVal)
        this.pageNumber=1;
        this.getByPage()
    },
    //编辑标题
    editeRemark(index,name){
        console.log(index)
        this.currentIndex=index;
        this.titleVal=name
    },
    changeTitle(id,orderSeqNo){
        let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';    
        const data = {
            id:id,
            registerId:userInfo && userInfo.id?userInfo.id:'',
            orderSeqNo:orderSeqNo,
            name:this.titleVal
        }
        _updateTitle(data).then(res => {
            if(res.code==200){
               this.currentIndex=null;
               this.getByPage()
            }
        });        
    },
    //详情
    pushInfo(item){
        this.$router.push({name:'evidenceInfo',query: {id:item}})
    },
    //重新截取
    againSubmit(val){
        // this.$router.push({name:'evidenceWeb',query: {id:val}})
        this.getRequest('/evidenceWebpage/get/'+val).then(res=>{
            if(res.code==200){
                let orderSeqNo=res.result.orderSeqNo;
                _getresave({orderSeqNo:orderSeqNo}).then(res => {
                    if(res.code==200){
                        this.getByPage()
                    }else{
                         toast(res.message)
                    }
                });               
            }else{
                toast(res.message)
            }
        })
    },
    //证据文件
    downUrl(item){
         if (item.packageUrl) {
            const links = item.packageUrl.replace('http://', 'https://');
            let aDom = document.createElement("a");
            aDom.target = "_self";
            aDom.href = links;
            aDom.download = links.substr(links.lastIndexOf('/'), links.length);
            aDom.click();
        }
      },
    //下载Bc
     downBcBook(id){
        window.open( this.API_ROOT_UPLOAD + "bqjvip/blockChain/tianPing/downloadBc?evidenceOrderSeqNos=" + id, '_self');
    },
    //证书核验
     openVerify(val){
        // let routeUrl = this.$router.resolve({
        //   path: "/index/creation_verification",
        //   name:'creationVerification',
        //   params: {type:this.flagType,id:val}
        // });
        // window.open(routeUrl.href, '_blank');
        window.open(this.API_ROOT_UPLOAD+"verification/" + this.flagType+'/'+val, '_blank');
    }
  },
  mounted() {
    this.getByPage()
  },
    }
</script>
<style scoped lang="less">
.bianji{
    position: relative;
    top:-7px;
    cursor: pointer;
}
.editeRemark{
    display: inline-block;
    width:220px;
    height:38px;
    background:rgba(255,255,255,1);
    border-radius:18px;
    border:1px solid rgba(229,231,234,1);
    margin-bottom: 7px;
    .editeRemark-input{
        height: 36px;
        border:0px;
        background:transparent;
        outline: none;
        color:#666;
        margin-left: 10px;
        font-size: 14px;
        width:175px;
        font-weight: 400;
        vertical-align: middle;
    }
    .editeRemark-search-icon{
        width:20px!important;
        height:20px!important;
        vertical-align: middle;
        cursor: pointer;
    }
}
.showphotow{
    display: inline-block;
    height: 100%;
    position:relative;
    margin-left: 20px;
    .showdiasy{
      position:absolute;
      top:35px;
      left:0px;
      background: #fff;
      box-shadow: 0 2px 18px 0 rgba(179,189,199,.47);
      border-radius: 4px;
      z-index:777;
      width: 110px;
      display:none;
      p{
        height:30px;
        line-height:30px;
        cursor:pointer;
        font-size: 12px;
        background-color: #fff;
        color: #929292;
      }
      a{
        color: #929292;
      }
      a:hover{
        color: #4e4e4e;  
      }
      p:hover{
        background-color: #f7f9fb;
        color: #4e4e4e;
      }
    }
    &:hover{
      .showdiasy{
        display:block;
      }
    }
  }
</style>